export default "__VITE_ASSET__ebfe191e__"